import React, {Component} from 'react';
import logo from '../../images/logo_dashbo_purple.svg';
import logotipo from '../../images/logotipo_dashbo_purple.svg';
import LoginButton from './LoginButton';
import Background from '../../images/login_bg.jpg';
import {TermsAndConditions} from "./TermsAndConditions";
import { withTranslation } from 'react-i18next';
import {APIClient} from "../../utils/APIClient";
import {LocalStorage} from "../../utils/LocalStorage";
import {Navigate} from "react-router-dom";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";

let sectionStyle = {
    backgroundImage: `url(${Background})`
};

class LoginPageComponent extends Component {
    render() {
        return (
            <div className="app-content">
                <LoginSidebar/>
                <LoginCover/>
            </div>
        );
    }
}

class SignUpPageComponent extends Component {
    render() {
        return (
            <div className="app-content sign-up">
                <LoginSidebar/>
                <LoginCover/>
            </div>
        );
    }
}

class LoginSidebarComponent extends Component {
    render() {
        const { t } = this.props;
        const isReviewLogin = window.location.search.includes('review-login');

        return (
            <div className="login-sidebar">
                <img src={logo} className="app-logo" alt="logo"/>
                <img src={logotipo} className="app-logo-name" alt="logotipo"/>
                <p className="tagline">{t('login.tagline')}</p>
                {isReviewLogin ? (
                    <PasswordLoginForm t={t}/>
                ) : (
                    <>
                        <h3 className="sign_up-text py-4 mt-5" >Registrá tu agencia y empezá gratis</h3>
                        <LoginButton/>
                        <TermsAndConditions/>
                    </>
                )}
            </div>
        );
    }
}

class PasswordLoginFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: {
                email: '',
                password: '',
            },
            saving: false,
            invalidCredentials: false,
            isLoggedIn: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true, invalidCredentials: false});

        new APIClient(API_URL + 'login/password/').login({...this.state.formData}).then((response) => {
            this.setState({saving: false});
            if (response === 'UNAUTHORIZED') {
                this.setState({invalidCredentials: true});
            } else {
                const userData = response.data;
                LocalStorage.saveUserData(
                    userData.user_id,
                    userData.token,
                    userData.user_type,
                    userData.agency_status,
                    userData.language,
                    null,
                    userData.is_dashbo_mcp,
                    userData.free_trial_days_remaining
                );
                this.setState({isLoggedIn: true});
            }
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            formData: {
                ...this.state.formData,
                [name]: target.value
            }
        });
    }

    render() {
        const { t } = this.props;
        if (this.state.isLoggedIn) {
            return <Navigate to={{pathname: '/'}}/>
        }

        return (
            <form className="login-form" onSubmit={this.handleSubmit} method="post" style={{marginTop: '2em'}}>
                <div className="form-row">
                    <input name="email" type="email" className="form-control"
                           placeholder={t('login.email_placeholder')}
                           value={this.state.formData.email} onChange={this.handleInputChange}/>
                </div>
                <div className="form-row">
                    <input name="password" type="password" className="form-control"
                           placeholder={t('login.password_placeholder')}
                           value={this.state.formData.password} onChange={this.handleInputChange}/>
                </div>
                <div className="submit-row">
                    {this.state.saving ? (
                        <button className="btn -alt" type="button" disabled>
                            <Spinner color="negative small"/>
                        </button>
                    ) : (
                        <input type="submit" value={t('login.login_button')} className="btn -alt"/>
                    )}
                </div>
                {this.state.invalidCredentials && (
                    <p className="login-message -fail" style={{marginTop: '1em', color: '#DF0D00'}}>
                        {t('login.invalid_credentials')}
                    </p>
                )}
            </form>
        );
    }
}

class LoginCoverComponent extends Component {
    render() {
        return (
            <div className="login-content cover" style={sectionStyle}>
                {/*<p className="slogan -main">Monitoreo y control de campañas</p>*/}
                {/*<p className="slogan">Averigua rápidamente si algo anda mal con tus cuentas y gestiona fácilmente el*/}
                {/*    presupuesto de tus clientes.</p>*/}
            </div>
        );
    }
}

const PasswordLoginForm = withTranslation()(PasswordLoginFormComponent);
export const LoginPage = withTranslation()(LoginPageComponent);
export const SignUpPage = withTranslation()(SignUpPageComponent);
export const LoginSidebar = withTranslation()(LoginSidebarComponent);
export const LoginCover = withTranslation()(LoginCoverComponent);
